import LockTableMouseEventsHandlerState from "./LockTableMouseEventsHandlerState";

export default class DelayedSelectionState extends LockTableMouseEventsHandlerState {
    constructor(mouseEventsHandler) {
        super(mouseEventsHandler);
        this.stateSwitcher = undefined;
    }

    setDelayedStateSwitcher(stateSwitcher) {
        this.stateSwitcher = stateSwitcher;
    }

    mouseOut(evt, cell) {
        this.stateSwitcher(this.mouseEventsHandler);
        this.mouseEventsHandler.mouseOut(evt, cell);
    }

    mouseUp(evt, cell) {
        this.mouseEventsHandler.setHoverState();
        this.mouseEventsHandler.mouseOver(null, cell);
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/DelayedSelectionState.js